import { render, staticRenderFns } from "./InspectionViewGlobal.vue?vue&type=template&id=702474d7"
import script from "./InspectionViewGlobal.vue?vue&type=script&lang=js"
export * from "./InspectionViewGlobal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports